import React, { useState } from 'react';
import { AlertTriangle, Trash2, X, Loader2 } from 'lucide-react';

export const DeletingAccountModal = () => {
  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center p-4" style={{ background: 'rgba(0, 0, 0, 0.98)' }}>
      <div className="bg-black border-2 border-red-500/50 rounded-2xl p-10 max-w-md w-full text-center">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-red-500/10 flex items-center justify-center">
          <Loader2 className="w-10 h-10 text-red-500 animate-spin" />
        </div>
        <h3 className="text-2xl font-bold text-white mb-3">Dein Account wird gelöscht…</h3>
        <p className="text-white/60 text-sm leading-relaxed">
          Wir entfernen gerade alle deine Daten, Avatare, Bilder und Credits. Bitte einen Moment Geduld.
        </p>
      </div>
    </div>
  );
};

export const DeleteAvatarModal = ({ avatarName, onConfirm, onCancel }) => {
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4" style={{ background: 'rgba(0, 0, 0, 0.98)' }}>
      <div className="bg-black border-2 border-orange-500/50 rounded-2xl p-8 max-w-md w-full text-center glow-green-soft">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-orange-500/20 flex items-center justify-center">
          <AlertTriangle className="w-8 h-8 text-orange-500" />
        </div>
        
        <h3 className="text-2xl font-bold text-white mb-3">Avatar löschen?</h3>
        <p className="text-white/70 text-base leading-relaxed mb-4">
          Möchtest du <span className="font-bold text-[#10B981]">"{avatarName}"</span> wirklich löschen?
        </p>
        <p className="text-white/60 text-sm leading-relaxed mb-6">
          <span className="font-bold text-orange-500">Alle generierten Bilder gehen verloren</span> und können nicht wiederhergestellt werden.
        </p>
        
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-6 py-3 border-2 border-white/30 text-white rounded-xl hover:bg-white/5 transition-all font-semibold"
          >
            Abbrechen
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-6 py-3 bg-orange-500 text-white rounded-xl hover:bg-orange-600 transition-all font-bold"
          >
            Ja, löschen
          </button>
        </div>
      </div>
    </div>
  );
};

export const DeleteAccountModal = ({ onConfirm, onCancel }) => {
  const [confirmText, setConfirmText] = useState('');
  const isConfirmed = confirmText === 'LÖSCHEN';

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4" style={{ background: 'rgba(0, 0, 0, 0.98)' }}>
      <div className="bg-black rounded-2xl p-8 max-w-md w-full text-center" style={{ border: '2px solid rgba(239, 68, 68, 0.5)' }}>
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-500/20 flex items-center justify-center">
          <Trash2 className="w-8 h-8 text-red-500" />
        </div>
        
        <h3 className="text-2xl font-bold text-white mb-3">Account löschen?</h3>
        <p className="text-white/70 text-sm leading-relaxed mb-6">
          <span className="font-bold text-red-500">Diese Aktion kann nicht rückgängig gemacht werden!</span><br/>
          Dein Account, alle Avatare, Bilder und Credits werden permanent gelöscht.
        </p>
        
        <div className="mb-6">
          <label className="block text-white/80 text-sm mb-2 text-left">
            Bitte tippe <span className="font-mono font-bold text-red-500">LÖSCHEN</span> ein, um fortzufahren:
          </label>
          <input
            type="text"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder="LÖSCHEN"
            className="w-full px-4 py-3 bg-black border-2 border-red-500/30 rounded-xl text-white placeholder:text-white/30 focus:border-red-500 focus:ring-2 focus:ring-red-500/50 transition-all text-center font-mono"
          />
        </div>
        
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-6 py-3 border-2 border-white/30 text-white rounded-xl hover:bg-white/5 transition-all font-semibold"
          >
            Abbrechen
          </button>
          <button
            onClick={onConfirm}
            disabled={!isConfirmed}
            className={`flex-1 px-6 py-3 rounded-xl font-bold transition-all ${
              isConfirmed
                ? 'bg-red-500 text-white hover:bg-red-600'
                : 'bg-white/10 text-white/40 cursor-not-allowed'
            }`}
          >
            Account löschen
          </button>
        </div>
      </div>
    </div>
  );
};
